import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import * as React from "react";
import { Textfit } from "react-textfit";
import { Question } from "src/pods/pairshare/types";
import { displayClose } from "src/pods/realtime";
import logEvent from "src/utils/logEvent";
import background from "src/pods/ideas/assets/combined_bubble.svg";

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class PairShareResult extends React.Component<{
  question?: Question;
  displayClose?: typeof displayClose;
}> {
  componentDidMount() {
    logEvent({
      eventName: "pairshare.result.open",
    });
  }

  componentWillUnmount() {
    logEvent({
      eventName: "pairshare.result.close",
    });
  }

  render() {
    const { question } = this.props;
    const text: string = question?.text || "";
    return (
      <div
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "dt_background_primary",
        }}
      >
        <div
          sx={{
            background: `url(${background})`,
            backgroundSize: "cover",
            height: "100vh",
          }}
        >
          <Textfit sx={pairShareResultTextfitStyle} max={64}>
            {text.split("\n").map((line) => (
              <div key={line} sx={{ margin: RAW_cssValue("0.5em 0") }}>
                {line}
              </div>
            ))}
          </Textfit>
        </div>
      </div>
    );
  }
}

const pairShareResultTextfitStyle: ThemeUIStyleObject = {
  fontWeight: 800,
  textAlign: "center",
  position: "absolute",
  top: "14.9%",
  left: "12.5%",
  right: "12.5%",
  bottom: "19.5%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "dt_content_accent",
  fontSize: "64px",
};
